"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DonationFeedback;

var _react = _interopRequireWildcard(require("react"));

var _reactPortal = require("react-portal");

var _contexts = require("../app/contexts");

var _backgroundSunglasses = _interopRequireDefault(require("./background-sunglasses"));

require("./donation-feedback.scss");

require("../box/box.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const FEEDBACK_DESTROY_DELAY = 15000; // in ms

function DonationFeedback(_ref) {
  let {
    hideFeedback
  } = _ref;
  const {
    strings
  } = (0, _react.useContext)(_contexts.Settings);
  const {
    reset
  } = (0, _react.useContext)(_contexts.Storage);
  const destroy = (0, _react.useCallback)(() => {
    hideFeedback();
    reset();
  }, [hideFeedback, reset]); // in case the user forgets to click: destroy & reset after a while automatically

  useCallbackDelay(destroy, FEEDBACK_DESTROY_DELAY);
  return /*#__PURE__*/_react.default.createElement(_reactPortal.Portal, {
    node: document.body
  }, /*#__PURE__*/_react.default.createElement(_backgroundSunglasses.default, {
    onClick: destroy
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "donation-encourager__feedback"
  }, /*#__PURE__*/_react.default.createElement("h3", null, strings.feedbackTitle), /*#__PURE__*/_react.default.createElement("p", null, strings.feedbackBody), /*#__PURE__*/_react.default.createElement("p", {
    className: "donation-encourager__cta"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "donation-encourager__button donation-encourager__cta-button",
    href: "#",
    onClick: e => {
      e.preventDefault();
      destroy();
    }
  }, strings.feedbackBtn)))));
}

function useCallbackDelay(callback, delay) {
  (0, _react.useEffect)(() => {
    setTimeout(callback, delay);
  }, [callback, delay]);
}